/*
 * @Date: 2021-04-16 09:11:08
 * @Author: zhujuan
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-01-18 13:40:31
 */
import adaptive from './adaptive'

const install = function (Vue) {
  // 绑定v-adaptive指令
  Vue.directive('adaptive', adaptive)
}

if (window.Vue) {
  window.adaptive = adaptive

  // eslint-disable-next-line no-undef

  Vue.use(install)
}

adaptive.install = install

export default adaptive
